<script>
	import { onMount } from "svelte";
	import util from "./util.js"

	class Vec2
	{
		constructor(x, y)
		{
			this.x = x;
			this.y = y;
		}

		copy()
		{
			return new Vec2(this.x, this.y);
		}

		length()
		{
			return Math.sqrt(this.dot(this));
		}

		add(v)
		{
			return new Vec2(this.x + v.x, this.y + v.y);
		}

		sub(v)
		{
			return new Vec2(this.x - v.x, this.y - v.y);
		}

		mul(f)
		{
			return new Vec2(this.x * f, this.y * f);
		}

		div(f)
		{
			return new Vec2(this.x / f, this.y / f);
		}

		distance(v)
		{
			return (this.sub(v)).length();
		}

		dirTo(v)
		{
			return v.sub(this).normalize();
		}

		dot(v)
		{
			return this.x * v.x + this.y * v.y;
		}

		normalize()
		{
			var l = this.length();
			if(l == 0.0) return this;
			return this.div(l);
		}
	};

	window.Vec2 = Vec2;

	function random(min, max)
	{
		return Math.random() * (max - min) + min;
	}

	function randomVec2(min, max)
	{
		return new Vec2(random(min, max), random(min, max));
	}

	class Node 
	{
		constructor(x, y, radius)
		{
			this.pos = new Vec2(x, y);
			this.vel = new Vec2(0.0, 0.0);
			this.radius = radius;
			this.color = "red";
			this.mass = 1.0;
		}

		collideBounds()
		{
			if(this.pos.x - this.radius < 0.0 || this.pos.x + this.radius > width){
				//this.pos.x = util.clamp(this.pos.x, 0.0, width);
				this.vel.x = -this.vel.x;
				/*
				if(this.pos.x - this.radius < 0.0 && this.vel.x < 0.0)
					this.vel.x = -this.vel.x;
				else if(this.pos.x + this.radius > width && this.vel.x > 0.0)
					this.vel.x = -this.vel.x;
					*/
			}
			if(this.pos.y - this.radius < 0.0 || this.pos.y + this.radius > height){
				//this.pos.y = util.clamp(this.pos.y, 0.0, height);
				this.vel.y = -this.vel.y;
				/*if(this.pos.y - this.radius < 0.0 && this.vel.y < 0.0)
					this.vel.y = -this.vel.y;
				else if(this.pos.y + this.radius > height && this.vel.y > 0.0)
					this.vel.y = -this.vel.y;*/
			}
		}
	};

	function arrayEquals(arr0, arr1)
	{
		if(arr0 == undefined || arr1 == undefined) return arr0 === arr1;
		if(arr0.length != arr1.length) return false;
		if(arr0 === arr1) return true;
		for(var i = 0; i < arr0.length; i++)
			if(arr0[i] != arr1[i]) return false;
		return true;
	}
	
	const corners = [new Vec2(-1, -1), new Vec2(-1, 1), new Vec2(1, -1), new Vec2(1, 1)];

	class BBox
	{
		constructor(min, max)
		{
			this.min = (min === undefined) ? new Vec2(width, height) : min;
			this.max = (max === undefined) ? new Vec2(0.0, 0.0) : max;
		}
		
		add(point)
		{
			if(point.x < this.min.x) this.min.x = point.x;
			if(point.y < this.min.y) this.min.y = point.y;
			if(point.x > this.max.x) this.max.x = point.x;
			if(point.y > this.max.y) this.max.y = point.y;
			return this;
		}

		inside(point)
		{
			if(point.x < this.min.x) return false;
			if(point.x > this.max.x) return false;
			if(point.y < this.min.y) return false;
			if(point.y > this.max.y) return false;
			return true;
		}
	};

	class Grid
	{
		constructor(width, height, cells)
		{
			this.width = width;
			this.height = height;
			this.cell_count = cells; //per dimension
			this.cells = [];
		}

		getIndex(x, y)
		{
			return y * this.cell_count + x;
		}

		toGrid(pos)
		{
			var x = Math.floor((pos.x / this.width) * this.cell_count);
			var y = Math.floor((pos.y / this.height) * this.cell_count);
			return new Vec2(x, y);
		}

		getCell(pos)
		{
			var coord = this.toGrid(pos);
			return this.getIndex(coord.x, coord.y);
		}

		getCells(pos, radius)
		{
			var res = [];
			
			var xmin = this.cell_count;
			var xmax = 0;
			var ymin = this.cell_count;
			var ymax = 0;

			var box = new BBox();
			for(var i = 0; i < corners.length; i++){
				var corner = corners[i];
				var p = pos.add(corner.mul(radius));
				box.add(this.toGrid(p));
			}
			for(var x = box.min.x; x <= box.max.x; x++){
				for(var y = box.min.y; y <= box.max.y; y++){
					var index = this.getIndex(x, y);
					if(res.indexOf(index) == -1)
						res.push(index);
				}
			}
			/*
			for(var x = -1; x < 2; x++){
				var dx = pos.x + x * radius;
				for(var y = -1; y < 2; y++){
					var dy = pos.y + y * radius;
					var xI = Math.floor((dx / this.width) * this.cell_count);
					var yI = Math.floor((dy / this.height) * this.cell_count);
					var index = this.getIndex(xI, yI);
					if(res.indexOf(index) == -1)
						res.push(index);
				}
			}*/
			res.sort((a, b) => a - b);
			return res;
		}

		addToCell(id, cellIndex)
		{
			var c = this.cells[cellIndex];
			if(c === undefined)
				this.cells[cellIndex] = [id];
			else c.push(id);
		}

		addPoint(id, pos, radius)
		{
			var cellList = this.getCells(pos, radius);
			for(var i = 0; i < cellList.length; i++){
				this.addToCell(id, cellList[i]);
			}
			return cellList;
		}

		removePoint(id, cellIndices)
		{
			for(var c = 0; c < cellIndices.length; c++){
				var cell = this.cells[cellIndices[c]];
				const index = cell.indexOf(id);
				if(index > -1){
					cell.splice(index, 1);
				}
			}
		}

		movePoint(id, lastPos, newPos, radius)
		{
			var cellsBefore = this.getCells(lastPos, radius);
			var cellsAfter = this.getCells(newPos, radius);
			if(arrayEquals(cellsBefore, cellsAfter)) return;
			for(var i = 0; i < cellsBefore.length; i++)
				this.removePoint(id, cellsBefore[i]);
			for(var i = 0; i < cellsAfter.length; i++)
				this.addToCell(id, cellsAfter[i]);
			return cellsAfter;
		}

		getNearby(ids, pos, radius, id)
		{
			var res = [];
			if(true || ids.length == 0){
				ids = this.getCells(pos, radius);
			}
			for(var c = 0; c < ids.length; c++){
				var cell = this.cells[ids[c]];
				if(!cell) continue;
				for(var i = 0; i < cell.length; i++){
					var index = cell[i];
					if(index == id) continue;
					var node = nodes[index];
					if(node.pos.distance(pos) < radius){
						res.push(index);
					}
				}
			}
			return res;
		}
	};

	function colorFromIndex(i, max)
	{
		var h = i / max;
		var rgb = util.HSVtoRGB(h, 1.0, 1.0);
		return util.rgb(rgb.r, rgb.g, rgb.b);
	}

	let width = window.innerWidth;
	let height = window.innerHeight;
	let pixelRatio = 1.0;
	let canvas;
	let context;
	let frame;
	let framerate = 0;

	let mouse = new Vec2(0.0, 0.0);

	let enableCollision = true;
	let grid;
	let nodes = [];
	let numPoints = 100;
	let numCells = 10;
	let pointSize = 5;

	function doNothing(node)
	{

	}

	function moveTowardTarget(node, speed)
	{
		if(!node.target) return;

		if(speed === undefined || isNaN(speed))
			speed = 2.0;

		let dir = node.pos.dirTo(node.target).mul(speed);
		// TODO
		if(dir.dot(node.vel) < 0.0){
			node.vel = node.vel.sub(node.vel.mul(0.1));
			node.vel = node.vel.add(dir.mul(0.1));
		}
		else{
			node.vel = node.vel.sub(node.vel.mul(0.1));
			node.vel = node.vel.add(dir.mul(0.1));
		}
	}

	function avoid(node, near)
	{
		var vel = new Vec2(0.0, 0.0);
		for(var i = 0; i < near.length; i++){
			var other = nodes[near[i]];
			vel = vel.sub(node.pos.dirTo(other.pos).mul(0.5));
		}

		if(vel.length() > 1.0)
			vel = vel.normalize();
		let target = node.pos.add(vel);
		node.target = target;
		return vel;
	}

	var boidParams = { speed: 3.0, avoidFac: 0.7, alignFac: 1.0, cohedeFac: 1.1 };
	function boid(node)
	{
		// separate, alignment, cohesion 
		var near = grid.getNearby(node.gridIds, node.pos, 100, node.id);
		if(near.length == 0) return;
		
		// separate
		var avoidDir = avoid(node, near);

		// get average pos and dir of nearby nodes
		let sumDir = node.vel.copy();
		let sumPos = node.pos.copy();
		for(var i = 0; i < near.length; i++){
			var n = nodes[near[i]];
			sumDir = sumDir.add(n.vel);
			sumPos = sumPos.add(n.pos);
		}
		
		let avgPos = sumPos.div(near.length + 1);
		let avgDir = sumDir.normalize();

		// clamp
		avgPos.x = util.clamp(avgPos.x, width * 0.1, width * 0.9);
		avgPos.y = util.clamp(avgPos.y, height * 0.1, height * 0.9);

		// alignment (follow group avgDir)
		var alignDir = avgDir;

		// cohesion (move towards group center)
		var cohesionDir = node.pos.dirTo(avgPos);
		
		var p = boidParams;
		var av = isNaN(p.avoidFac) ? 1.0 : p.avoidFac;
		var al = isNaN(p.alignFac) ? 1.0 : p.alignFac;
		var co = isNaN(p.cohedeFac) ? 1.0 : p.cohedeFac;
		var sp = isNaN(p.speed) ? 1.0 : p.speed;
		
		var totalDir = avoidDir.mul(av);
		totalDir = totalDir.add(alignDir.mul(al));
		totalDir = totalDir.add(cohesionDir.mul(co));
		node.target = node.pos.add(totalDir);
		
		//let vel = avgDir.normalize().add(node.vel.mul(0.75)).normalize();
		// cohesion
		//let vel2 = vel.mul(1.5).add(pos.sub(node.pos).normalize()).normalize();
		//node.target = node.pos.add(vel2);
		moveTowardTarget(node, sp);
		//node.vel = node.vel.add(dir.normalize());
		//node.vel = node.vel.normalize();
		//node.vel = node.vel.add(pos.sub(node.pos).normalize());
		//node.vel = node.vel.normalize();
	}

	function avoidNearest(node)
	{
		var near = grid.getNearby(node.gridIds, node.pos, 100, node.id);
		avoid(node, near);
		moveTowardTarget(node);
	}

	var nodeUpdateFns = [ doNothing, avoidNearest, boid ];
	var updateParams = { boid: boidParams };
	var selectedNodeUpdateFn = nodeUpdateFns[0];

	function colorByGridCell(node)
	{
		return colorFromIndex(node.gridIds[0], grid.cell_count * grid.cell_count);
	}

	function colorById(node)
	{
		return colorFromIndex(node.id, nodes.length);
	}

	function colorByNumNeighbors(node)
	{
		var num = grid.getNearby(node.gridIds, node.pos, 50, node.id).length;
		return util.rgb(util.HSVtoRGB(0.0, Math.min(num / 30, 1.0), 1.0));
	}

	var colorBy = [ colorByGridCell, colorById, colorByNumNeighbors ];
	var selectedColorFn = colorBy[0];

	function init()
	{
		nodes = [];
		grid = new Grid(width, height, numCells);
		for(var i = 0; i < numPoints; i++){
			var node = new Node( random(0.0, width), random(0.0, height), pointSize);
			node.vel = randomVec2(-1.0, 1.0);
			node.gridIds = grid.addPoint(i, node.pos, node.radius);
			//node.color = selectedColorFn(node);
			node.id = nodes.length;
			nodes.push(node);
		}
		window.grid = grid;
		window.nodes = nodes;
	}

	function resolveCollision(node0, node1)
	{
		// get the mtd
		var delta = (node0.pos.sub(node1.pos));
		var d = delta.length();
		d = Math.max(d, 0.001);
		// minimum translation distance to push balls apart after intersecting
		var mtd = delta.mul(((node0.radius + node1.radius)-d)/d);

		// resolve intersection --
		// inverse mass quantities
		var im1 = 1 / node0.mass;
		var im2 = 1 / node1.mass;

		// push-pull them apart based off their mass
		node0.pos = node0.pos.add(mtd.mul(im1 / (im1 + im2)));
		node1.pos = node1.pos.sub(mtd.mul(im2 / (im1 + im2)));

		// impact speed
		var v = (node0.vel.sub(node1.vel));
		var vn = v.dot(mtd.normalize());

		// sphere intersecting but moving away from each other already
		if (vn > 0.0) return;

		var restitution = 1.0;
		// collision impulse
		var i = (-(1.0 + restitution) * vn) / (im1 + im2);
		var impulse = mtd.normalize().mul(i);

		// change in momentum
		node0.vel = node0.vel.add(impulse.mul(im1));
		node1.vel = node1.vel.sub(impulse.mul(im2));
	}

	function update(elapsed, dt)
	{
		framerate = 1.0 / dt;
		if(enableCollision){
			for(var c = 0; c < grid.cells.length ; c++){
				var cell = grid.cells[c];
				if(cell === undefined || cell.length < 2) continue;
				for(var j = 0; j < cell.length; j++){
					var node0 = nodes[cell[j]];
					for(var k = j + 1; k < cell.length; k++){
						var node1 = nodes[cell[k]];
						if(node0.pos.distance(node1.pos) < node0.radius + node1.radius){
							resolveCollision(node0, node1);
						}
					}	
				}
			}
		}
		
		for(var i = 0; i < nodes.length; i++){
			var node = nodes[i]
			var posBefore = node.pos.copy();
			
			selectedNodeUpdateFn(node);
			node.pos = node.pos.add(node.vel);
			grid.removePoint(i, node.gridIds);
			node.gridIds = grid.addPoint(i, node.pos, node.radius);
			//node.gridId = grid.movePoint(i, `posBefore, node.pos, node.radius);
			node.color = selectedColorFn(node);
			node.collideBounds();
		}
	}

	var debug = false;

	function render(elapsed, dt)
	{
		context.clearRect(0, 0, canvas.width, canvas.height);
		context.beginPath();
		
		nodes.sort(function(a, b){ return a.color < b.color; });

		var prevColor;
		for(var i = 0; i < nodes.length; i++){
			var node = nodes[i];
			if(prevColor && node.color != prevColor){
				context.strokeStyle = prevColor;
				context.stroke();
				context.beginPath();
			}
			else{
				context.moveTo(node.pos.x + node.radius, node.pos.y);
			}
			
			context.arc(node.pos.x, node.pos.y, node.radius, 0, 2 * Math.PI, false);
			
			prevColor = node.color;
		}
		if(prevColor){
			context.strokeStyle = prevColor;
			context.stroke();
		}

		if(debug){
			context.beginPath();
			context.arc(mouse.x, mouse.y, 1.0, 0, 2 * Math.PI, false);
			context.fillStyle = "white";
			context.fill();
			context.closePath();
			context.beginPath();
			var near = grid.getNearby([], mouse, 100, -1);
			for(var i = 0; i < near.length; i++){
				var other = nodes[near[i]];
				context.moveTo(mouse.x, mouse.y);
				context.lineTo(other.pos.x, other.pos.y);
			}
			context.strokeStyle = "white";
			context.stroke();
			context.closePath();
		}
	}

	function loop(elapsed, dt)
	{
		update(elapsed, dt);
		render(elapsed, dt);
	}

	onMount(()=>{
		context = canvas.getContext("2d");
		init();
		return createLoop(loop);
	});

	function createLoop (fn) {
		let elapsed = 0;
		let lastTime = performance.now();
		(function loop() {
			frame = requestAnimationFrame(loop);
			const beginTime = performance.now();
			const dt = (beginTime - lastTime) / 1000;
			lastTime = beginTime;
			elapsed += dt;
			fn(elapsed, dt);
		})();
		return () => {
			cancelAnimationFrame(frame);
		};
	}

	function handleMousemove(event) {
		mouse.x = event.clientX;
		mouse.y = event.clientY;
	}
</script>

<canvas on:mousemove={handleMousemove}
bind:this={canvas}
width={width * pixelRatio}
height={height * pixelRatio}
style="width: {width}px; height: {height}px;"></canvas>

<div id="Stats">
	<div>FPS: { Math.round(framerate) }</div>
	<div>Points: <input on:change={ init } bind:value={ numPoints }/></div>
	<div>Grid: <input on:change={ init } bind:value={ numCells }/></div>
	<div>Radius: <input on:change={ init } bind:value={ pointSize }/></div>
	<div>Collide: <input class="checkbox" type="checkbox" bind:checked={ enableCollision }/></div>
	<div>Debug: <input class="checkbox" type="checkbox" bind:checked={ debug }/></div>
	<div>CellLogic:<select bind:value={selectedNodeUpdateFn}>
		{#each nodeUpdateFns as fn}
			<option value={fn}>
				{fn.name}
			</option>
		{/each}
	</select></div>
	<div>Color:<select bind:value={selectedColorFn}>
		{#each colorBy as fn}
			<option value={fn}>
				{fn.name}
			</option>
		{/each}
	</select></div>
	{#if updateParams[selectedNodeUpdateFn.name] }
		{#each Object.keys(updateParams[selectedNodeUpdateFn.name]) as param}
			<div>{ param }: <input bind:value={ updateParams[selectedNodeUpdateFn.name][param] }> </div>
		{/each}
	{/if}
	
</div>

<style>
	:global(body){
		background: #000;
		background-color: #000;
		width: 100%;
		height: 100%;
		margin: 0px;
		padding: 0px;
		overflow: hidden;
	}

	#Stats
	{
		font-size: 80%;
		position: absolute;
		background-color: rgba(22, 19, 19, 0.9);
		padding: 20px;
		left: 20px;
		top: 20px;
		color: white;
	}

	#Stats div 
	{
		margin-top: 2px;
	}

	.checkbox
	{
		appearance: none;
		background-color: rgba(0.0, 0.0, 0.0, 0.0);
		border-radius: 2px;
		font-size: 90%;
		color: white;
	}

	.checkbox:checked
	{
		background-color: rgba(65, 125, 238, 0.795);
	} 

	input, select {
		background-color: rgba(0.0, 0.0, 0.0, 0.0);
		border-radius: 20px;
		font-size: 90%;
		color: white;
	}
</style>